import React from 'react';
import { CircleCheckBig, Clock } from 'lucide-react';

import { JOB_STATUS } from 'src/constants';

type Props={
    workerPlan: WorkerPlanType;
    taskStatus: string;
    size?:'large' | 'medium' | 'small'
  };

const WorkerAvatar:React.FC<Props> = ({ workerPlan,size, taskStatus }) => {

  const initials = `${workerPlan?.worker?.first_name?.[0] ?? ''}${workerPlan?.worker?.last_name?.[0] ?? ''}`;

  const backgroundColorClass =
    taskStatus === JOB_STATUS.progress
      ? 'bg-orange-500 text-white font-semibold'
      : taskStatus === 'COMPLETE'
      ? 'bg-white'
      : 'bg-transparent';

  const avatarSize = size === 'large'
    ? 'text-[16px] w-10 h-10 rounded-md'
    : taskStatus === 'medium'
    ? 'text-[14px]'
    : 'text-[10px] w-5 h-5 rounded-sm';

  return (
    <div>
      {workerPlan?.worker?.first_name && (
        <div className="m-auto relative">
          <div
            className={` flex items-center justify-center p-[0.5px] mx-auto ${avatarSize} ${backgroundColorClass}`}
          >
            <p>{initials}</p>
          </div>
          <div className="absolute bottom-0 right-0 mr-[-12px]">
            {taskStatus === JOB_STATUS.progress ? (
              <Clock size={10} className="text-orange-500 bg-white rounded-full" />
            ) : taskStatus === JOB_STATUS.complete ? (
              <CircleCheckBig size={10} className="text-green-700 bg-white rounded-full" />
            ) : null}
          </div>
        </div>
      )}
    </div>
  );
};

export default WorkerAvatar;
